import { useNavigate } from 'react-router-dom';
import { articles, hotArticles } from '../../../mocks/articles';

export default function FeaturePicks() {
  const navigate = useNavigate();
  const main = articles.find((a) => a.id === 4)!;
  const side = hotArticles.filter((a) => a.id !== main.id).slice(0, 4);

  return (
    <section id="chennian" className="scroll-mt-20 bg-background-50">
      <div className="container-x py-12 md:py-16">
        <div className="flex items-center gap-3">
          <span className="h-6 w-1.5 rounded-full bg-primary-500"></span>
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-700">EDITOR PICK</p>
            <h2 className="mt-0.5 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              本周编辑精选 · 陈年旧瓜
            </h2>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 主卡 */}
          <article
            onClick={() => navigate(`/article/${main.id}`)}
            className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-7"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden">
              <img
                src={main.cover}
                alt={main.coverAlt}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent"></div>
              <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                本周头条
              </span>
            </div>
            <div className="relative -mt-16 flex flex-1 flex-col justify-end p-5 md:p-6">
              <h3 className="max-w-xl font-display text-xl font-black leading-snug text-background-50 md:text-2xl">
                {main.title}
              </h3>
              <p className="mt-3 line-clamp-2 max-w-2xl text-sm leading-6 text-background-50/85">{main.excerpt}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-50/70">
                <span className="inline-flex items-center gap-1.5"><i className="ri-user-line"></i>{main.author}</span>
                <span className="inline-flex items-center gap-1.5"><i className="ri-time-line"></i>{main.readTime}</span>
                <span className="inline-flex items-center gap-1.5"><i className="ri-calendar-line"></i>{main.date.slice(0, 10)}</span>
              </div>
            </div>
          </article>

          {/* 侧边列表 */}
          <div className="flex flex-col gap-3 lg:col-span-5">
            {side.map((a, idx) => (
              <button
                key={a.id}
                onClick={() => navigate(`/article/${a.id}`)}
                className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-3.5 text-left transition-all hover:border-primary-300 hover:bg-background-200/50"
              >
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-background-200 font-display text-xl font-black text-accent-600">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                    {a.title}
                  </h3>
                  <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                    <span>{a.category}</span>
                    <i className="ri-eye-line"></i>{(a.views / 1000).toFixed(1)}k
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}